// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root' // Makes it singleton and globally available
// })
// export class LoaderService {
//   private _loading = new BehaviorSubject<boolean>(false);
//   loading$ = this._loading.asObservable();

//   show() { this._loading.next(true); }
//   hide() { this._loading.next(false); }
// }


import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private pending = 0;

  private _loading = new BehaviorSubject<boolean>(false);
  loading$ = this._loading.asObservable();

  show(): void {
    this.pending++;
    if (this.pending === 1) {
      this._loading.next(true);
    }
  }

  hide(): void {
    if (this.pending > 0) this.pending--;

    // Only hide when *all* pending operations finished
    if (this.pending === 0) {
      this._loading.next(false);
    }
  }

  // Optional safety (useful if you ever want to force reset)
  reset(): void {
    this.pending = 0;
    this._loading.next(false);
  }
}
